
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from "../login-controlador";
    import { Email } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model.Recuperar; }
        get UsuarioActual() { return Model.Recuperar.UsuarioActual; }

        Estado: 'cargando' | 'iniciado' = 'iniciado';
        Error: string = '';
        Usuario: string = '';

        Siguiente( m: string )
        {
            this.$emit( 'modo', m );
        }

        public async Comprobar()
        {


            if ( this.Usuario.length < 3 )
            {
                this.Error = '¡Ingresá un usuario válido!';
                return;
            }

            this.Estado = 'cargando';
            let response = await this.Controlador.ComprobarUsuario( this.Usuario.toLowerCase(), 'u' );
            if ( response != "ok" )
            {
                this.Usuario = '';
                document.getElementById( 'text-usuario' ).focus();
                if ( response == "datos-incorrectos" )
                {
                    this.Error = '¡El usuario ingresado no existe!';
                }
                else if ( response == "error" )
                {
                    this.Error = 'Ocurrió un error en el servicio';
                }
            }
            this.Estado = 'iniciado';
        }

    }
